export const updateUserDetail = (data) => ({
  type: "UPDATE_USER_DETAIL",
  data,
});

export const updateUserDetailNotification = data => ({
  type:"UPDATE_USER_DETAIL_NOTIFICATION",
  data
})